import { render } from "./ViewSubmittedCompliance.vue?vue&type=template&id=4b2543fc"
import script from "./ViewSubmittedCompliance.vue?vue&type=script&lang=js"
export * from "./ViewSubmittedCompliance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__